// #1246: ゲストの表示名。この端末の localStorage にのみ保存し、アカウント
// (サーバ側 profile) には一切影響しない。ログイン時は user.name が優先される。
// logout 時の clearLocalStoragePreservingDeviceId で消えるのは意図どおり
// (アカウントを離れた端末に他人の名前を残さない)。

const KEY = 'yokoso.guestProfile.v1'

export function getGuestName(): string {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return ''
    const parsed = JSON.parse(raw) as { name?: unknown }
    return typeof parsed.name === 'string' ? parsed.name.trim() : ''
  } catch {
    return ''
  }
}

export function setGuestName(name: string): void {
  localStorage.setItem(KEY, JSON.stringify({ name: name.trim() }))
}
